import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  KeyboardView,
  Title,
  ContentfulRichText,
  Copy,
  Button
} from "app/NativeComponents/common";
import {
  Header,
  PillButton,
  CheckBoxInput
} from "app/NativeComponents/snippets";

import { renderDate } from "app/NativeActions";
class FinalCancelPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pause_mailers: true
    };
  }

  componentDidMount() {}
  componentDidUpdate(prevProps) {}

  render() {
    const {
      cancel_page,
      cancel_center_content,
      device,
      is_last_plan,
      first_cancel_reason,
      second_cancel_reason,
      next_billing_date
    } = this.props;
    const { pause_mailers } = this.state;

    return (
      <Wrapper style={{ flex: 1 }}>
        <Header
          title={cancel_page.title}
          leftButtonIcon={"arrow-back"}
          leftButtonAction={() => {
            if (cancel_center_content.showPauseOption && is_last_plan) {
              this.props.optOutOfPaused(false);
            } else {
              this.props.setSecondCancelReason(null);
            }
          }}
        />
        <KeyboardView
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Wrapper
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              margin: device == "desktop" ? "0px auto" : 0
            }}
          >
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: 650,
                padding: 20
              }}
            >
              <Wrapper style={{ paddingTop: 20, paddingBottom: 20 }}>
                <Title style={{ textAlign: "center", marginBottom: 10 }}>
                  {cancel_center_content.finalCancelTitle}
                </Title>
                <ContentfulRichText
                  style={{ textAlign: "center" }}
                  richText={cancel_center_content.finalCancelDescription}
                />
                {/* Copy about the final date  */}
                <Copy>
                  You'll have access to DealMachine until{" "}
                  {renderDate(next_billing_date, true)}
                </Copy>
                {/* Toggle to pause mailers now vs later */}
                <CheckBoxInput
                  onPress={() =>
                    this.setState({
                      pause_mailers: !pause_mailers
                    })
                  }
                  value={pause_mailers}
                  title={""}
                  componentView={() => {
                    return (
                      <Wrapper
                        style={{
                          alignItems: "flex-start",
                          justfyContent: "center"
                        }}
                      >
                        <Copy style={{ textAlign: "left" }}>
                          Stop all mailer marketing before my billing cycle
                          ends.
                        </Copy>
                      </Wrapper>
                    );
                  }}
                />
              </Wrapper>
              <Wrapper style={{ paddingBottom: 40 }}>
                <PillButton
                  deleteButton={true}
                  onPress={() => {
                    this.props.updatePlan({
                      token: this.props.token,
                      type: "cancel_plan",
                      slug: cancel_page.engine_slug,
                      first_cancel_reason,
                      second_cancel_reason,
                      pause_mailers,
                      onSuccess: () => {
                        this.props.handleBack();
                      }
                    });
                  }}
                >
                  {cancel_center_content.finalCancelButton}
                </PillButton>
              </Wrapper>
            </Wrapper>
          </Wrapper>
        </KeyboardView>
      </Wrapper>
    );
  }
}

export default FinalCancelPage;
